import { Out } from "@/infrastructure/frontent/clientMessage";
import { GeoJsonRoot, LeafletAccessor, MapGebietRow } from "./geo-json-types";
import { GeoJsonUtils } from "./geo-json";
import { openDialog } from "@/infrastructure/observables/ModalDialogNotification";

export class GeoJsonRenderer {
    constructor(private leafletAccessor: LeafletAccessor) {}



    public clearLayers () {
        const { L, map } = this.leafletAccessor;
        try {
            map.eachLayer(function (layer: any) {
                if (layer.toGeoJSON) {
                    map.removeLayer(layer);
                }
            });
        } catch (e) {
            Out.noOperation()
        }


    }


    public draw(geoJsonUtils: GeoJsonUtils) : void {
        const { L, map } = this.leafletAccessor;

        try {
            map.fitBounds(geoJsonUtils.getBoundingBox(geoJsonUtils.getRevier() as MapGebietRow));
        } catch (e) {
            console.log("Error fitting bounds: ", e);
        }

        for (const row of geoJsonUtils.getMapGebiete()) {
            if (!row.mapGebietGeoJson) continue;
            if (typeof row.mapGebietGeoJson === "object" && row.mapGebietGeoJson !== null && (row.mapGebietGeoJson as any).type === "FeatureCollection") {
                if(row.mapGebietGeoJson.features[0].geometry?.type === "MultiLineString" || row.mapGebietGeoJson.features[0].geometry?.type === "LineString") {
                   this.drawLineString(L, map, row);
                   continue
                }
               this.drawGeoJsonPolygon(L, map, row);
            }
        }
    }

    // LineString and MultiLineString
    private drawLineString(L: any, map: any, gebiet: MapGebietRow) : void {
        if (!gebiet.mapGebietGeoJson) return;

     
        const geoJsonLayer = L.geoJSON(gebiet.mapGebietGeoJson, {
            style: { 
                color: gebiet.farbcodeRand || '#3388ff', 
                weight: gebiet.dickeRand !== undefined && gebiet.dickeRand !== null ? parseFloat(gebiet.dickeRand as any) : 1 , 
                fillOpacity: gebiet.opacity || 0.2,
                fillColor: gebiet.farbcodeFlaeche || '#3388ff'
            },                
            onEachFeature: (feature: any, layer: any) => {
                layer.on('click', (e: any) => {
                    this.showLayerInformation(gebiet);
                });
            }

        });

        geoJsonLayer.addTo(map);
    }


    // Polygon and MultiPolygon
    private drawGeoJsonPolygon(L: any, map: any, gebiet: MapGebietRow) : void {
        if (!gebiet.mapGebietGeoJson) return;


        const geoJsonLayer = L.geoJSON(gebiet.mapGebietGeoJson, {
            style: { 
                color: gebiet.farbcodeRand || '#3388ff', 
                weight: gebiet.dickeRand !== undefined && gebiet.dickeRand !== null ? parseFloat(gebiet.dickeRand as any) : 1, 
                fillOpacity: gebiet.opacity || 0.2,
                fillColor: gebiet.farbcodeFlaeche || '#3388ff'
            },            
            onEachFeature: (feature: any, layer: any) => {
                layer.on('click', (e: any) => {
                    this.showLayerInformation(gebiet);
                });
            }
        });

        geoJsonLayer.addTo(map);
    }

    private showLayerInformation(row: MapGebietRow) : void {
        if (row.mapGebietResourceText && row.mapGebietResourceText.length > 1) {
            this.openLayerInformation("", row.mapGebietResourceText ?? "");
        }
    }

     private openLayerInformation(title: string | undefined, content: string | undefined) : void {
      if ( title === undefined)
        title = ""
      if ( content === undefined)
        content = ""

      openDialog(this.leafletAccessor.store, {name: "Information", isOk: true, isCancel: false, titel: `${title}`, text: `${content}`, open: true, type: "info"})
    }

}
